// extracted by mini-css-extract-plugin
module.exports = {"modal-scroll":"Saturation_modal-scroll__Gl8T_","saturationArea":"Saturation_saturationArea__gneaW","pointer":"Saturation_pointer__Y_rhc"};